import { useEffect, useMemo } from 'react'
import { Modal } from '@panwds/react-ui'
import type { FC, CSSProperties } from 'react'
import type { ModalProps } from '@panwds/react-ui'

export { ModalHeader, ModalBody, ModalFooter, useModal } from '@panwds/react-ui'

const ModalWithIndexFix: FC<ModalProps & { center?: boolean }> = ({ center, children, style, ...props }) => {
  const modStyle = useMemo(() => {
    const modStyle = { ...style } as CSSProperties
    if (modStyle.zIndex === undefined) {
      modStyle.zIndex = 1051
    }
    if (modStyle.minHeight === undefined) {
      modStyle.minHeight = 50
    }
    Object.assign(modStyle, {
      top: '50%',
      '--tw-translate-y': '-50%',
    })
    return modStyle
  }, [style])

  useEffect(() => {
    const modalMask = props.isOpen && document.querySelector('.tw-bg-gray-900.tw-fixed.tw-inset-0.tw-z-10.tw-transition-opacity.tw-duration-200.tw-opacity-75') as HTMLDivElement | null
    if (modalMask) {
      modalMask.style.zIndex = String(modStyle.zIndex)
    }
  }, [modStyle.zIndex, props.isOpen])

  return (
    <Modal {...props} style={modStyle}>{children}</Modal>
  )
}

export { ModalWithIndexFix as Modal }

export default ModalWithIndexFix
